export default function AboutSection() {
  return (
    <section className="w-full bg-background-50">
      <div className="flex flex-col lg:flex-row min-h-[500px]">
        <div className="w-full lg:w-[55%] px-6 md:px-12 py-16 md:py-20 flex flex-col justify-center">
          <h3 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950 leading-tight tracking-tight">
            Built for
            <br />
            reliability and
            <br />
            long-term quality
          </h3>
        </div>

        <div className="w-full lg:w-[45%] relative min-h-[300px] lg:min-h-full">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20soft%20geometric%20shapes%20in%20warm%20terracotta%20and%20blush%20tones%2C%20overlapping%20rounded%20rectangles%20and%20ellipses%2C%20minimalist%20composition%2C%20clean%20contemporary%20design%2C%20subtle%20texture%2C%20no%20text%20no%20people%2C%20calm%20atmospheric%20gradient%20background%2C%20editorial%20quality%2C%20high%20resolution&width=800&height=700&seq=about-deco-tubi-2026&orientation=landscape"
            alt="Abstract geometric decorative composition"
            title="TubiConsult AB design philosophy"
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
}